import { Box, Button, IconButton, MenuItem, Typography } from '@mui/material';
import FormRow from 'components/form/FormRow';
import { useFieldValue } from 'components/form/input/NestedField'
import SelectInput from 'components/form/input/SelectInput';
import { fetchArray } from 'entity';
import Perfil from 'entity/Perfil';
import React from 'react'
import { useEffect } from 'react';
import { useCallback } from 'react';
import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import TextInput from 'components/form/input/TextInput';
function CardPerfil({ perfis, uid, deletePerfil, updatePerfil }) {
    let perfilAtual = { uid: '', name: '', email: '' };

    if (perfis.length && uid !== '') {
        perfilAtual = perfis.find(p => p.uid === uid)
    }

    // console.log('perfilAtual', perfilAtual)
    // console.log('perfis', perfis)

    return <FormRow
        sx={{
            justifyContent: "center",
            mb: 1,
            backgroundColor: "rgba(125,125,125,0.2)",
            p: 1,
        }}
    >
        <SelectInput
            sx={{ flex: 1 }}
            name="name"
            label="Nome do Colaborador"
            value={perfilAtual?.uid}
            onChange={e => { updatePerfil(e.target.value) }}

        >

            {perfis.map((p, i) => <MenuItem key={i} value={p.uid}>{p.name}</MenuItem>)}
        </SelectInput>
        <TextInput
            type="email"
            name="email"
            label="E-mail"
            disabled
            value={perfilAtual?.email}
            InputLabelProps={{
                shrink: true,
            }}
        />
        <IconButton aria-label="delete" onClick={deletePerfil}>
            <DeleteIcon />
        </IconButton>
    </FormRow>
}

function PerfisAutorizados({ name, label }) {
    const [perfisAutorizados, setPerfisAutorizados] = useFieldValue(name)

    const [perfis, setPerfis] = useState([])

    const loadPerfis = useCallback(async () => {
        // Carrega apenas uma vez.
        if (perfis.length === 0) {
            const result = await fetchArray(Perfil.getAll());

            setPerfis([...result.map(({ name, email, uid }) => ({ name, email, uid }))]);
        }
    }, [perfis.length]);

    useEffect(() => {
        loadPerfis();
    }, [loadPerfis]);

    const newProfile = () => {
        setPerfisAutorizados(['', ...perfisAutorizados])
    }

    const deletePerfil = (index) => {
        let array = [...perfisAutorizados]

        array.splice(index, 1);
        setPerfisAutorizados(array);
    }

    const updatePerfil = (index, uid) => {
        let array = [...perfisAutorizados]
        array[index] = uid
        setPerfisAutorizados(array);
    }


    return (
        <Box sx={{ display: "flex", flexBasis: "100%", flexDirection: "column" }}>
            <FormRow sx={{ display: "flex", justifyContent: 'space-between', alignitems: 'center', flexWrap: 'nowrap' }}>
                <Typography variant="h6">{label}</Typography>
                <Button onClick={newProfile} style={{ margin: 20, alignSelf: 'flex-end' }} startIcon={<AddIcon />}>Novo Perfil</Button>
            </FormRow>
            {/* <FormRow sx={{ display: "flex", justifyContent: 'center', mb: 3 }}>
                <Typography variant="h6">{label}</Typography>
            </FormRow> */}
            {perfisAutorizados.length !== 0
                ? perfisAutorizados.map((perfilUid, index) => (
                    <CardPerfil
                        key={index}
                        index={index}
                        perfis={
                            perfis.filter(p => {
                                // é um perfil autorizado e não é o perfil selecionado nesse card? false
                                if (perfisAutorizados.includes(p.uid) && perfilUid !== p.uid) {
                                    return false;
                                }
                                return true;
                            })
                        }
                        uid={perfilUid}
                        updatePerfil={uid =>
                            updatePerfil(index, uid)
                        }
                        deletePerfil={() =>
                            deletePerfil(index)
                        }
                    />
                ))
                : <FormRow sx={{ display: "flex", justifyContent: 'center' }}>
                    <Typography sx={{ color: 'text.disabled' }}>- Nenhum Perfil Autorizado -</Typography>
                </FormRow>
            }

        </Box>
    )
}

export default PerfisAutorizados